export default {
  year: 2025,
  generated_at: '2026-05-12T13:53:13Z',
  from_date: '2025-01-01',
  to_date: '2025-12-31',
  total_contributors: 930,
  total_merged_mrs: 4119,
  min_merged_mrs: 5,
  team_snapshot: 'app/javascript/pages/top-annual-contributors-page/data/team-snapshots/team_members_2025-12-31.yml',
  excluded_by_team_snapshot: [
    'DylanGriffith',
    'JasonAkin',
    'annabeldunstone',
    'avanbelleghem-gl',
    'lmalagriccia',
    'lmcnally1',
    'mdunninger',
    'msedlakjakubowski',
  ],
  excluded_explicitly: [
    'amulvany',
    'andrcuns',
    'bprescott_',
    'chrisfraser',
    'digitalmoksha',
    'eurie',
    'himkp',
    'hoegaarden',
    'jarka',
    'khimes',
    'leipert',
    'mschoenlaub',
    'mwilkins',
    'oregand',
    'rhardarson',
    'sarahhchapman',
    'twoodham',
  ],
  contributors: [
    {
      user_id: 18657743,
      username: 'heidi.berry',
      contributor_level: 5,
      opened_merge_requests: 308,
      merged_merge_requests: 299,
      merged_with_issues: 111,
      merged_commits: 301,
      added_notes: 1189,
      opened_issues: 39,
      added_labels: 59,
      closed_issues: 27,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 33450,
      plan_points: 1578,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 100,
      score: 35128,
    },
    {
      user_id: 4375199,
      username: 'gerardo-navarro',
      contributor_level: 5,
      opened_merge_requests: 150,
      merged_merge_requests: 102,
      merged_with_issues: 82,
      merged_commits: 103,
      added_notes: 1068,
      opened_issues: 68,
      added_labels: 0,
      closed_issues: 0,
      added_events: 2,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 5,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 13640,
      plan_points: 1408,
      engage_points: 1000,
      discuss_points: 11,
      translate_points: 0,
      bonus_points: 100,
      score: 16159,
    },
    {
      user_id: 22462169,
      username: 'bluefly',
      contributor_level: 4,
      opened_merge_requests: 241,
      merged_merge_requests: 136,
      merged_with_issues: 0,
      merged_commits: 54,
      added_notes: 134,
      opened_issues: 272,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 14060,
      plan_points: 1494,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 15554,
    },
    {
      user_id: 5219924,
      username: 'Taucher2003',
      contributor_level: 5,
      opened_merge_requests: 80,
      merged_merge_requests: 74,
      merged_with_issues: 14,
      merged_commits: 75,
      added_notes: 626,
      opened_issues: 20,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 5,
      discord_replies: 360,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 4,
      code_points: 7960,
      plan_points: 726,
      engage_points: 0,
      discuss_points: 725,
      translate_points: 0,
      bonus_points: 4700,
      score: 14111,
    },
    {
      user_id: 8095268,
      username: 'PatrickRice',
      contributor_level: 5,
      opened_merge_requests: 100,
      merged_merge_requests: 90,
      merged_with_issues: 33,
      merged_commits: 150,
      added_notes: 2400,
      opened_issues: 9,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 11390,
      plan_points: 2445,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 13835,
    },
    {
      user_id: 7423230,
      username: 'syedzubeen',
      contributor_level: 4,
      opened_merge_requests: 96,
      merged_merge_requests: 80,
      merged_with_issues: 51,
      merged_commits: 81,
      added_notes: 189,
      opened_issues: 6,
      added_labels: 1,
      closed_issues: 0,
      added_events: 0,
      added_contents: 1,
      discord_messages: 9,
      discord_replies: 15,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 927,
      ai_contributions: 0,
      bonuses: 2,
      code_points: 9870,
      plan_points: 220,
      engage_points: 200,
      discuss_points: 39,
      translate_points: 1227,
      bonus_points: 200,
      score: 11756,
    },
    {
      user_id: 10927805,
      username: 'jimender2',
      contributor_level: 4,
      opened_merge_requests: 20,
      merged_merge_requests: 15,
      merged_with_issues: 10,
      merged_commits: 10,
      added_notes: 231,
      opened_issues: 17,
      added_labels: 349,
      closed_issues: 697,
      added_events: 1,
      added_contents: 0,
      discord_messages: 36,
      discord_replies: 476,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 2,
      code_points: 1800,
      plan_points: 5645,
      engage_points: 500,
      discuss_points: 988,
      translate_points: 0,
      bonus_points: 200,
      score: 9133,
    },
    {
      user_id: 1494491,
      username: 'nwittstruck',
      contributor_level: 4,
      opened_merge_requests: 66,
      merged_merge_requests: 60,
      merged_with_issues: 58,
      merged_commits: 61,
      added_notes: 476,
      opened_issues: 21,
      added_labels: 5,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 7880,
      plan_points: 586,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 8466,
    },
    {
      user_id: 5628777,
      username: 'karras',
      contributor_level: 4,
      opened_merge_requests: 59,
      merged_merge_requests: 55,
      merged_with_issues: 50,
      merged_commits: 54,
      added_notes: 561,
      opened_issues: 5,
      added_labels: 1,
      closed_issues: 2,
      added_events: 1,
      added_contents: 0,
      discord_messages: 6,
      discord_replies: 93,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 7060,
      plan_points: 597,
      engage_points: 500,
      discuss_points: 192,
      translate_points: 0,
      bonus_points: 0,
      score: 8349,
    },
    {
      user_id: 27488429,
      username: 'network-charles',
      contributor_level: 4,
      opened_merge_requests: 65,
      merged_merge_requests: 62,
      merged_with_issues: 58,
      merged_commits: 64,
      added_notes: 240,
      opened_issues: 2,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 8040,
      plan_points: 250,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 8290,
    },
    {
      user_id: 2392209,
      username: 'CoachEd',
      contributor_level: 4,
      opened_merge_requests: 92,
      merged_merge_requests: 61,
      merged_with_issues: 27,
      merged_commits: 61,
      added_notes: 163,
      opened_issues: 11,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 18,
      discord_replies: 14,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 7530,
      plan_points: 218,
      engage_points: 0,
      discuss_points: 46,
      translate_points: 0,
      bonus_points: 100,
      score: 7894,
    },
    {
      user_id: 25217369,
      username: 'abutkeev',
      contributor_level: 4,
      opened_merge_requests: 31,
      merged_merge_requests: 32,
      merged_with_issues: 11,
      merged_commits: 33,
      added_notes: 141,
      opened_issues: 5,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 3302,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 3530,
      plan_points: 166,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 4108,
      bonus_points: 0,
      score: 7804,
    },
    {
      user_id: 30375223,
      username: 'therealrinku',
      contributor_level: 4,
      opened_merge_requests: 58,
      merged_merge_requests: 41,
      merged_with_issues: 33,
      merged_commits: 42,
      added_notes: 325,
      opened_issues: 12,
      added_labels: 1,
      closed_issues: 3,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 5,
      code_points: 5450,
      plan_points: 401,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 1100,
      score: 6951,
    },
    {
      user_id: 14375494,
      username: 'jdve',
      contributor_level: 4,
      opened_merge_requests: 66,
      merged_merge_requests: 66,
      merged_with_issues: 0,
      merged_commits: 66,
      added_notes: 2,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 6600,
      plan_points: 7,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 6607,
    },
    {
      user_id: 907418,
      username: 'abitrolly',
      contributor_level: 4,
      opened_merge_requests: 45,
      merged_merge_requests: 42,
      merged_with_issues: 27,
      merged_commits: 43,
      added_notes: 630,
      opened_issues: 45,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 8,
      discord_replies: 20,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 5090,
      plan_points: 855,
      engage_points: 0,
      discuss_points: 48,
      translate_points: 0,
      bonus_points: 100,
      score: 6093,
    },
    {
      user_id: 25229781,
      username: 'n.h.long.9697',
      contributor_level: 3,
      opened_merge_requests: 26,
      merged_merge_requests: 18,
      merged_with_issues: 17,
      merged_commits: 19,
      added_notes: 202,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 9,
      discord_replies: 28,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 6,
      code_points: 2490,
      plan_points: 207,
      engage_points: 0,
      discuss_points: 65,
      translate_points: 0,
      bonus_points: 2600,
      score: 5362,
    },
    {
      user_id: 3526849,
      username: 'eazybright',
      contributor_level: 3,
      opened_merge_requests: 36,
      merged_merge_requests: 35,
      merged_with_issues: 35,
      merged_commits: 35,
      added_notes: 126,
      opened_issues: 1,
      added_labels: 13,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 3,
      discord_replies: 10,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 2,
      code_points: 4570,
      plan_points: 144,
      engage_points: 0,
      discuss_points: 23,
      translate_points: 0,
      bonus_points: 200,
      score: 4937,
    },
    {
      user_id: 25858123,
      username: 'ayushjhawar499',
      contributor_level: 3,
      opened_merge_requests: 6,
      merged_merge_requests: 6,
      merged_with_issues: 6,
      merged_commits: 6,
      added_notes: 63,
      opened_issues: 0,
      added_labels: 2772,
      closed_issues: 257,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 4,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 780,
      plan_points: 4120,
      engage_points: 0,
      discuss_points: 9,
      translate_points: 0,
      bonus_points: 0,
      score: 4909,
    },
    {
      user_id: 14154601,
      username: 'n7800',
      contributor_level: 3,
      opened_merge_requests: 34,
      merged_merge_requests: 30,
      merged_with_issues: 11,
      merged_commits: 30,
      added_notes: 664,
      opened_issues: 44,
      added_labels: 109,
      closed_issues: 69,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 3410,
      plan_points: 1338,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 100,
      score: 4848,
    },
    {
      user_id: 5396833,
      username: 'YoanSimco',
      contributor_level: 4,
      opened_merge_requests: 47,
      merged_merge_requests: 47,
      merged_with_issues: 0,
      merged_commits: 47,
      added_notes: 49,
      opened_issues: 6,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 4700,
      plan_points: 79,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 4779,
    },
    {
      user_id: 6878211,
      username: 'elC0mpa',
      contributor_level: 3,
      opened_merge_requests: 43,
      merged_merge_requests: 28,
      merged_with_issues: 25,
      merged_commits: 8,
      added_notes: 251,
      opened_issues: 6,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 3,
      discord_messages: 19,
      discord_replies: 48,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 2,
      code_points: 3450,
      plan_points: 281,
      engage_points: 600,
      discuss_points: 115,
      translate_points: 0,
      bonus_points: 200,
      score: 4646,
    },
    {
      user_id: 20730986,
      username: 'hichemdahi57',
      contributor_level: 3,
      opened_merge_requests: 33,
      merged_merge_requests: 25,
      merged_with_issues: 23,
      merged_commits: 25,
      added_notes: 120,
      opened_issues: 7,
      added_labels: 3,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 9,
      discord_replies: 28,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 1,
      ai_contributions: 0,
      bonuses: 8,
      code_points: 3350,
      plan_points: 158,
      engage_points: 0,
      discuss_points: 65,
      translate_points: 1,
      bonus_points: 900,
      score: 4474,
    },
    {
      user_id: 21130389,
      username: 'Deepak18-06',
      contributor_level: 4,
      opened_merge_requests: 52,
      merged_merge_requests: 28,
      merged_with_issues: 27,
      merged_commits: 28,
      added_notes: 116,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 2,
      code_points: 4090,
      plan_points: 126,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 200,
      score: 4416,
    },
    {
      user_id: 852944,
      username: 'alexandear',
      contributor_level: 3,
      opened_merge_requests: 44,
      merged_merge_requests: 41,
      merged_with_issues: 4,
      merged_commits: 42,
      added_notes: 41,
      opened_issues: 3,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 4300,
      plan_points: 56,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 4356,
    },
    {
      user_id: 29088934,
      username: 'webmekanic',
      contributor_level: 4,
      opened_merge_requests: 18,
      merged_merge_requests: 12,
      merged_with_issues: 12,
      merged_commits: 12,
      added_notes: 199,
      opened_issues: 2,
      added_labels: 1906,
      closed_issues: 6,
      added_events: 0,
      added_contents: 0,
      discord_messages: 3,
      discord_replies: 10,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 3,
      code_points: 1680,
      plan_points: 2145,
      engage_points: 0,
      discuss_points: 23,
      translate_points: 0,
      bonus_points: 400,
      score: 4248,
    },
    {
      user_id: 2566574,
      username: 'Bubbis',
      contributor_level: 3,
      opened_merge_requests: 32,
      merged_merge_requests: 30,
      merged_with_issues: 29,
      merged_commits: 30,
      added_notes: 195,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 2,
      discord_replies: 8,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 3910,
      plan_points: 200,
      engage_points: 0,
      discuss_points: 18,
      translate_points: 0,
      bonus_points: 0,
      score: 4128,
    },
    {
      user_id: 27545521,
      username: 'sahiljawale541',
      contributor_level: 3,
      opened_merge_requests: 34,
      merged_merge_requests: 30,
      merged_with_issues: 30,
      merged_commits: 30,
      added_notes: 56,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 16,
      added_events: 0,
      added_contents: 0,
      discord_messages: 3,
      discord_replies: 1,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 3980,
      plan_points: 136,
      engage_points: 0,
      discuss_points: 5,
      translate_points: 0,
      bonus_points: 0,
      score: 4121,
    },
    {
      user_id: 21381525,
      username: 'poojaghanghas479',
      contributor_level: 3,
      opened_merge_requests: 23,
      merged_merge_requests: 14,
      merged_with_issues: 13,
      merged_commits: 14,
      added_notes: 451,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 8,
      discord_replies: 37,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 5,
      code_points: 1970,
      plan_points: 451,
      engage_points: 0,
      discuss_points: 82,
      translate_points: 0,
      bonus_points: 1400,
      score: 3903,
    },
    {
      user_id: 14384063,
      username: 'oceane_scania',
      contributor_level: 3,
      opened_merge_requests: 26,
      merged_merge_requests: 24,
      merged_with_issues: 23,
      merged_commits: 26,
      added_notes: 491,
      opened_issues: 12,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 3170,
      plan_points: 551,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 3721,
    },
    {
      user_id: 29580426,
      username: 'official.harshith1',
      contributor_level: 3,
      opened_merge_requests: 34,
      merged_merge_requests: 21,
      merged_with_issues: 18,
      merged_commits: 20,
      added_notes: 183,
      opened_issues: 4,
      added_labels: 25,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 2,
      discord_replies: 4,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 2,
      code_points: 2880,
      plan_points: 233,
      engage_points: 0,
      discuss_points: 10,
      translate_points: 0,
      bonus_points: 451,
      score: 3574,
    },
    {
      user_id: 4040366,
      username: 'florian.heberl',
      contributor_level: 3,
      opened_merge_requests: 37,
      merged_merge_requests: 31,
      merged_with_issues: 4,
      merged_commits: 31,
      added_notes: 126,
      opened_issues: 8,
      added_labels: 18,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 3340,
      plan_points: 189,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 3529,
    },
    {
      user_id: 22746419,
      username: 'ttbt0706',
      contributor_level: 3,
      opened_merge_requests: 41,
      merged_merge_requests: 30,
      merged_with_issues: 0,
      merged_commits: 25,
      added_notes: 159,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 3120,
      plan_points: 159,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 3279,
    },
    {
      user_id: 30028690,
      username: 'Ahmad-Faraj',
      contributor_level: 3,
      opened_merge_requests: 38,
      merged_merge_requests: 23,
      merged_with_issues: 23,
      merged_commits: 12,
      added_notes: 51,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 3,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 3070,
      plan_points: 51,
      engage_points: 0,
      discuss_points: 6,
      translate_points: 0,
      bonus_points: 100,
      score: 3227,
    },
    {
      user_id: 12053347,
      username: 'luzhiyuan.deer',
      contributor_level: 4,
      opened_merge_requests: 11,
      merged_merge_requests: 10,
      merged_with_issues: 2,
      merged_commits: 10,
      added_notes: 78,
      opened_issues: 4,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 2459,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1080,
      plan_points: 98,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 2001,
      bonus_points: 0,
      score: 3179,
    },
    {
      user_id: 5332,
      username: 'bbodenmiller',
      contributor_level: 5,
      opened_merge_requests: 32,
      merged_merge_requests: 28,
      merged_with_issues: 1,
      merged_commits: 28,
      added_notes: 181,
      opened_issues: 8,
      added_labels: 8,
      closed_issues: 2,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2910,
      plan_points: 239,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 3149,
    },
    {
      user_id: 13093824,
      username: 'clement.bois',
      contributor_level: 3,
      opened_merge_requests: 30,
      merged_merge_requests: 26,
      merged_with_issues: 0,
      merged_commits: 27,
      added_notes: 233,
      opened_issues: 36,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2700,
      plan_points: 413,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 3113,
    },
    {
      user_id: 29076834,
      username: 'ashu07das',
      contributor_level: 3,
      opened_merge_requests: 31,
      merged_merge_requests: 21,
      merged_with_issues: 21,
      merged_commits: 18,
      added_notes: 151,
      opened_issues: 0,
      added_labels: 1,
      closed_issues: 2,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2870,
      plan_points: 162,
      engage_points: 0,
      discuss_points: 1,
      translate_points: 0,
      bonus_points: 0,
      score: 3033,
    },
    {
      user_id: 44745,
      username: 'xrow',
      contributor_level: 3,
      opened_merge_requests: 33,
      merged_merge_requests: 28,
      merged_with_issues: 0,
      merged_commits: 28,
      added_notes: 50,
      opened_issues: 3,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2900,
      plan_points: 65,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2965,
    },
    {
      user_id: 28232529,
      username: 'rodrigofarii',
      contributor_level: 3,
      opened_merge_requests: 22,
      merged_merge_requests: 21,
      merged_with_issues: 21,
      merged_commits: 15,
      added_notes: 181,
      opened_issues: 1,
      added_labels: 1,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 3,
      discord_replies: 3,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 2630,
      plan_points: 187,
      engage_points: 0,
      discuss_points: 9,
      translate_points: 0,
      bonus_points: 100,
      score: 2926,
    },
    {
      user_id: 10402615,
      username: 'vj35.cool',
      contributor_level: 3,
      opened_merge_requests: 21,
      merged_merge_requests: 19,
      merged_with_issues: 19,
      merged_commits: 19,
      added_notes: 106,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 2,
      code_points: 2510,
      plan_points: 106,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 200,
      score: 2816,
    },
    {
      user_id: 12198778,
      username: 'antonkalmykov',
      contributor_level: 4,
      opened_merge_requests: 20,
      merged_merge_requests: 20,
      merged_with_issues: 20,
      merged_commits: 20,
      added_notes: 157,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2600,
      plan_points: 162,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2762,
    },
    {
      user_id: 12968147,
      username: 'ajuckel',
      contributor_level: 3,
      opened_merge_requests: 26,
      merged_merge_requests: 16,
      merged_with_issues: 10,
      merged_commits: 16,
      added_notes: 392,
      opened_issues: 14,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 12,
      discord_replies: 66,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2100,
      plan_points: 462,
      engage_points: 0,
      discuss_points: 144,
      translate_points: 0,
      bonus_points: 0,
      score: 2706,
    },
    {
      user_id: 26951788,
      username: 'Mithradevi_Kumar',
      contributor_level: 3,
      opened_merge_requests: 30,
      merged_merge_requests: 16,
      merged_with_issues: 16,
      merged_commits: 16,
      added_notes: 96,
      opened_issues: 21,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 4,
      discord_replies: 3,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 2360,
      plan_points: 201,
      engage_points: 0,
      discuss_points: 10,
      translate_points: 0,
      bonus_points: 100,
      score: 2671,
    },
    {
      user_id: 173375,
      username: 'zakaria-fatahi',
      contributor_level: 3,
      opened_merge_requests: 34,
      merged_merge_requests: 16,
      merged_with_issues: 13,
      merged_commits: 15,
      added_notes: 136,
      opened_issues: 3,
      added_labels: 3,
      closed_issues: 24,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 61,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2330,
      plan_points: 274,
      engage_points: 0,
      discuss_points: 1,
      translate_points: 61,
      bonus_points: 0,
      score: 2666,
    },
    {
      user_id: 10923734,
      username: 'crenz',
      contributor_level: 3,
      opened_merge_requests: 23,
      merged_merge_requests: 19,
      merged_with_issues: 18,
      merged_commits: 19,
      added_notes: 107,
      opened_issues: 3,
      added_labels: 0,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2520,
      plan_points: 127,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2647,
    },
    {
      user_id: 23077376,
      username: 'umarajamani',
      contributor_level: 3,
      opened_merge_requests: 23,
      merged_merge_requests: 20,
      merged_with_issues: 14,
      merged_commits: 20,
      added_notes: 68,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2480,
      plan_points: 68,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2548,
    },
    {
      user_id: 22745451,
      username: 'vvpatil123',
      contributor_level: 3,
      opened_merge_requests: 48,
      merged_merge_requests: 24,
      merged_with_issues: 0,
      merged_commits: 5,
      added_notes: 40,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2500,
      plan_points: 40,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2540,
    },
    {
      user_id: 27668000,
      username: 'sergiy_kulanov',
      contributor_level: 0,
      opened_merge_requests: 25,
      merged_merge_requests: 25,
      merged_with_issues: 0,
      merged_commits: 25,
      added_notes: 0,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2500,
      plan_points: 0,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2500,
    },
    {
      user_id: 25736558,
      username: 'chaitanyason9',
      contributor_level: 3,
      opened_merge_requests: 18,
      merged_merge_requests: 15,
      merged_with_issues: 7,
      merged_commits: 15,
      added_notes: 190,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 1770,
      plan_points: 190,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 500,
      score: 2460,
    },
    {
      user_id: 19691920,
      username: 'erik.petzold1',
      contributor_level: 3,
      opened_merge_requests: 19,
      merged_merge_requests: 15,
      merged_with_issues: 3,
      merged_commits: 15,
      added_notes: 101,
      opened_issues: 14,
      added_labels: 0,
      closed_issues: 0,
      added_events: 1,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 1670,
      plan_points: 171,
      engage_points: 500,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 100,
      score: 2441,
    },
    {
      user_id: 555423,
      username: 'cfleee',
      contributor_level: 2,
      opened_merge_requests: 15,
      merged_merge_requests: 14,
      merged_with_issues: 11,
      merged_commits: 14,
      added_notes: 111,
      opened_issues: 6,
      added_labels: 41,
      closed_issues: 6,
      added_events: 0,
      added_contents: 0,
      discord_messages: 3,
      discord_replies: 26,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 2,
      code_points: 1750,
      plan_points: 212,
      engage_points: 0,
      discuss_points: 55,
      translate_points: 0,
      bonus_points: 400,
      score: 2417,
    },
    {
      user_id: 31073999,
      username: 'CryptoSquazz',
      contributor_level: 3,
      opened_merge_requests: 16,
      merged_merge_requests: 16,
      merged_with_issues: 14,
      merged_commits: 10,
      added_notes: 49,
      opened_issues: 55,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 9,
      discord_replies: 27,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 1900,
      plan_points: 324,
      engage_points: 0,
      discuss_points: 63,
      translate_points: 0,
      bonus_points: 100,
      score: 2387,
    },
    {
      user_id: 24646435,
      username: 'guptapratibha26',
      contributor_level: 3,
      opened_merge_requests: 20,
      merged_merge_requests: 13,
      merged_with_issues: 13,
      merged_commits: 14,
      added_notes: 199,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 1850,
      plan_points: 204,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 300,
      score: 2354,
    },
    {
      user_id: 29079264,
      username: 'therealharshit',
      contributor_level: 2,
      opened_merge_requests: 18,
      merged_merge_requests: 17,
      merged_with_issues: 17,
      merged_commits: 17,
      added_notes: 65,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 5,
      discord_replies: 12,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2230,
      plan_points: 65,
      engage_points: 0,
      discuss_points: 29,
      translate_points: 0,
      bonus_points: 0,
      score: 2324,
    },
    {
      user_id: 20364955,
      username: 'benmurel',
      contributor_level: 2,
      opened_merge_requests: 26,
      merged_merge_requests: 18,
      merged_with_issues: 12,
      merged_commits: 13,
      added_notes: 55,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2220,
      plan_points: 60,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2280,
    },
    {
      user_id: 9080899,
      username: 'Deltamir',
      contributor_level: 3,
      opened_merge_requests: 36,
      merged_merge_requests: 22,
      merged_with_issues: 0,
      merged_commits: 10,
      added_notes: 1,
      opened_issues: 5,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2240,
      plan_points: 26,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2266,
    },
    {
      user_id: 8841583,
      username: 'mness',
      contributor_level: 3,
      opened_merge_requests: 19,
      merged_merge_requests: 18,
      merged_with_issues: 10,
      merged_commits: 18,
      added_notes: 133,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 2120,
      plan_points: 138,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2258,
    },
    {
      user_id: 14485925,
      username: 'ahmad-kashkoush',
      contributor_level: 2,
      opened_merge_requests: 14,
      merged_merge_requests: 11,
      merged_with_issues: 11,
      merged_commits: 11,
      added_notes: 174,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 1,
      added_contents: 0,
      discord_messages: 7,
      discord_replies: 18,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1490,
      plan_points: 179,
      engage_points: 500,
      discuss_points: 43,
      translate_points: 0,
      bonus_points: 0,
      score: 2212,
    },
    {
      user_id: 23560311,
      username: 'onasser',
      contributor_level: 3,
      opened_merge_requests: 18,
      merged_merge_requests: 12,
      merged_with_issues: 12,
      merged_commits: 12,
      added_notes: 333,
      opened_issues: 5,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 10,
      discord_replies: 38,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1680,
      plan_points: 358,
      engage_points: 0,
      discuss_points: 86,
      translate_points: 0,
      bonus_points: 0,
      score: 2124,
    },
    {
      user_id: 19304051,
      username: 'mbo5be',
      contributor_level: 2,
      opened_merge_requests: 12,
      merged_merge_requests: 13,
      merged_with_issues: 13,
      merged_commits: 18,
      added_notes: 322,
      opened_issues: 2,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1770,
      plan_points: 332,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2102,
    },
    {
      user_id: 26184939,
      username: 'lincmba',
      contributor_level: 2,
      opened_merge_requests: 18,
      merged_merge_requests: 15,
      merged_with_issues: 15,
      merged_commits: 14,
      added_notes: 51,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1990,
      plan_points: 51,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 2041,
    },
    {
      user_id: 23183905,
      username: 'protsivd',
      contributor_level: 2,
      opened_merge_requests: 29,
      merged_merge_requests: 13,
      merged_with_issues: 0,
      merged_commits: 14,
      added_notes: 299,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1640,
      plan_points: 304,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1944,
    },
    {
      user_id: 2835149,
      username: 'pismy',
      contributor_level: 3,
      opened_merge_requests: 13,
      merged_merge_requests: 15,
      merged_with_issues: 0,
      merged_commits: 18,
      added_notes: 416,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1520,
      plan_points: 416,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1936,
    },
    {
      user_id: 2279743,
      username: 'gbonnefille',
      contributor_level: 3,
      opened_merge_requests: 13,
      merged_merge_requests: 8,
      merged_with_issues: 0,
      merged_commits: 49,
      added_notes: 109,
      opened_issues: 14,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1720,
      plan_points: 179,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1899,
    },
    {
      user_id: 10925656,
      username: 'vedant-jain03',
      contributor_level: 3,
      opened_merge_requests: 11,
      merged_merge_requests: 14,
      merged_with_issues: 14,
      merged_commits: 14,
      added_notes: 123,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1760,
      plan_points: 123,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1883,
    },
    {
      user_id: 8840348,
      username: 'cedric3.olivier',
      contributor_level: 2,
      opened_merge_requests: 18,
      merged_merge_requests: 18,
      merged_with_issues: 0,
      merged_commits: 19,
      added_notes: 33,
      opened_issues: 5,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1820,
      plan_points: 58,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1878,
    },
    {
      user_id: 30709974,
      username: 'yashes7516',
      contributor_level: 2,
      opened_merge_requests: 13,
      merged_merge_requests: 13,
      merged_with_issues: 13,
      merged_commits: 13,
      added_notes: 52,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 1690,
      plan_points: 57,
      engage_points: 0,
      discuss_points: 1,
      translate_points: 0,
      bonus_points: 100,
      score: 1848,
    },
    {
      user_id: 18831109,
      username: 'alexandre.laroche.exfo',
      contributor_level: 2,
      opened_merge_requests: 30,
      merged_merge_requests: 10,
      merged_with_issues: 7,
      merged_commits: 10,
      added_notes: 123,
      opened_issues: 20,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1610,
      plan_points: 223,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1833,
    },
    {
      user_id: 5403659,
      username: 'thelooter',
      contributor_level: 2,
      opened_merge_requests: 11,
      merged_merge_requests: 10,
      merged_with_issues: 6,
      merged_commits: 10,
      added_notes: 66,
      opened_issues: 2,
      added_labels: 15,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 43,
      discord_replies: 124,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1200,
      plan_points: 91,
      engage_points: 0,
      discuss_points: 291,
      translate_points: 0,
      bonus_points: 0,
      score: 1582,
    },
    {
      user_id: 1927592,
      username: 'ajeymuthiah',
      contributor_level: 2,
      opened_merge_requests: 16,
      merged_merge_requests: 11,
      merged_with_issues: 11,
      merged_commits: 11,
      added_notes: 43,
      opened_issues: 0,
      added_labels: 1,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1530,
      plan_points: 44,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1574,
    },
    {
      user_id: 27778046,
      username: 'nishant19072003',
      contributor_level: 2,
      opened_merge_requests: 16,
      merged_merge_requests: 11,
      merged_with_issues: 11,
      merged_commits: 11,
      added_notes: 31,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1530,
      plan_points: 31,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1561,
    },
    {
      user_id: 2235372,
      username: 'pmhahn',
      contributor_level: 3,
      opened_merge_requests: 12,
      merged_merge_requests: 11,
      merged_with_issues: 6,
      merged_commits: 10,
      added_notes: 147,
      opened_issues: 5,
      added_labels: 2,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 1,
      forum_replies: 3,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 1280,
      plan_points: 174,
      engage_points: 0,
      discuss_points: 7,
      translate_points: 0,
      bonus_points: 100,
      score: 1561,
    },
    {
      user_id: 3079581,
      username: 'zillemarco',
      contributor_level: 4,
      opened_merge_requests: 12,
      merged_merge_requests: 11,
      merged_with_issues: 2,
      merged_commits: 12,
      added_notes: 179,
      opened_issues: 3,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 13,
      discord_replies: 76,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1200,
      plan_points: 194,
      engage_points: 0,
      discuss_points: 165,
      translate_points: 0,
      bonus_points: 0,
      score: 1559,
    },
    {
      user_id: 28074319,
      username: 'SamyakJ05',
      contributor_level: 2,
      opened_merge_requests: 15,
      merged_merge_requests: 11,
      merged_with_issues: 11,
      merged_commits: 11,
      added_notes: 33,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1510,
      plan_points: 33,
      engage_points: 0,
      discuss_points: 1,
      translate_points: 0,
      bonus_points: 0,
      score: 1544,
    },
    {
      user_id: 15308696,
      username: 'alexander.marston',
      contributor_level: 3,
      opened_merge_requests: 12,
      merged_merge_requests: 11,
      merged_with_issues: 9,
      merged_commits: 11,
      added_notes: 82,
      opened_issues: 2,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 2,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1390,
      plan_points: 92,
      engage_points: 0,
      discuss_points: 5,
      translate_points: 0,
      bonus_points: 0,
      score: 1487,
    },
    {
      user_id: 26335567,
      username: 'bhanutejach9',
      contributor_level: 2,
      opened_merge_requests: 15,
      merged_merge_requests: 10,
      merged_with_issues: 10,
      merged_commits: 11,
      added_notes: 45,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 2,
      discord_replies: 2,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1420,
      plan_points: 45,
      engage_points: 0,
      discuss_points: 6,
      translate_points: 0,
      bonus_points: 0,
      score: 1471,
    },
    {
      user_id: 20223654,
      username: 'salihudickson',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 11,
      merged_with_issues: 10,
      merged_commits: 11,
      added_notes: 84,
      opened_issues: 4,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1360,
      plan_points: 104,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1464,
    },
    {
      user_id: 1271560,
      username: 'jotolo',
      contributor_level: 2,
      opened_merge_requests: 14,
      merged_merge_requests: 10,
      merged_with_issues: 8,
      merged_commits: 10,
      added_notes: 94,
      opened_issues: 1,
      added_labels: 1,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 2,
      discord_replies: 4,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1320,
      plan_points: 100,
      engage_points: 0,
      discuss_points: 10,
      translate_points: 0,
      bonus_points: 0,
      score: 1430,
    },
    {
      user_id: 538931,
      username: 'munishkumar631',
      contributor_level: 2,
      opened_merge_requests: 13,
      merged_merge_requests: 11,
      merged_with_issues: 11,
      merged_commits: 4,
      added_notes: 73,
      opened_issues: 2,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1330,
      plan_points: 83,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1413,
    },
    {
      user_id: 1589155,
      username: 'chetannn',
      contributor_level: 0,
      opened_merge_requests: 14,
      merged_merge_requests: 14,
      merged_with_issues: 0,
      merged_commits: 14,
      added_notes: 7,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1400,
      plan_points: 12,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1412,
    },
    {
      user_id: 12299077,
      username: 'mnazir',
      contributor_level: 2,
      opened_merge_requests: 10,
      merged_merge_requests: 10,
      merged_with_issues: 10,
      merged_commits: 10,
      added_notes: 60,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1300,
      plan_points: 65,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1365,
    },
    {
      user_id: 11542448,
      username: 'sge70',
      contributor_level: 2,
      opened_merge_requests: 10,
      merged_merge_requests: 10,
      merged_with_issues: 6,
      merged_commits: 10,
      added_notes: 82,
      opened_issues: 7,
      added_labels: 8,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1180,
      plan_points: 130,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1310,
    },
    {
      user_id: 11636842,
      username: 'mkuurstra',
      contributor_level: 4,
      opened_merge_requests: 15,
      merged_merge_requests: 14,
      merged_with_issues: 0,
      merged_commits: 6,
      added_notes: 1,
      opened_issues: 8,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1260,
      plan_points: 41,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1301,
    },
    {
      user_id: 6265352,
      username: 'edith007',
      contributor_level: 4,
      opened_merge_requests: 16,
      merged_merge_requests: 7,
      merged_with_issues: 7,
      merged_commits: 7,
      added_notes: 201,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1090,
      plan_points: 206,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1296,
    },
    {
      user_id: 2090646,
      username: 'rndmh3ro',
      contributor_level: 3,
      opened_merge_requests: 11,
      merged_merge_requests: 10,
      merged_with_issues: 6,
      merged_commits: 6,
      added_notes: 25,
      opened_issues: 6,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 1120,
      plan_points: 55,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 100,
      score: 1275,
    },
    {
      user_id: 22474531,
      username: 'mohammedfirdouss',
      contributor_level: 2,
      opened_merge_requests: 16,
      merged_merge_requests: 7,
      merged_with_issues: 6,
      merged_commits: 7,
      added_notes: 201,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1060,
      plan_points: 201,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1261,
    },
    {
      user_id: 9547685,
      username: 'sayeedahmad',
      contributor_level: 3,
      opened_merge_requests: 11,
      merged_merge_requests: 10,
      merged_with_issues: 7,
      merged_commits: 10,
      added_notes: 27,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1230,
      plan_points: 27,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1257,
    },
    {
      user_id: 9776733,
      username: 'maxbrundige444',
      contributor_level: 2,
      opened_merge_requests: 16,
      merged_merge_requests: 10,
      merged_with_issues: 10,
      merged_commits: 0,
      added_notes: 23,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1220,
      plan_points: 23,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1243,
    },
    {
      user_id: 2293954,
      username: 'Fishbowler',
      contributor_level: 0,
      opened_merge_requests: 15,
      merged_merge_requests: 12,
      merged_with_issues: 0,
      merged_commits: 11,
      added_notes: 1,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1240,
      plan_points: 1,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1241,
    },
    {
      user_id: 23477414,
      username: 'ariestar',
      contributor_level: 2,
      opened_merge_requests: 16,
      merged_merge_requests: 9,
      merged_with_issues: 6,
      merged_commits: 8,
      added_notes: 23,
      opened_issues: 1,
      added_labels: 1,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1200,
      plan_points: 29,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1229,
    },
    {
      user_id: 5358464,
      username: 'choznerol',
      contributor_level: 2,
      opened_merge_requests: 12,
      merged_merge_requests: 9,
      merged_with_issues: 6,
      merged_commits: 9,
      added_notes: 61,
      opened_issues: 2,
      added_labels: 0,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1140,
      plan_points: 76,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1216,
    },
    {
      user_id: 11401339,
      username: 'antoineOG',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 8,
      merged_with_issues: 5,
      merged_commits: 8,
      added_notes: 84,
      opened_issues: 7,
      added_labels: 1,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 3,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 970,
      plan_points: 120,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 3,
      bonus_points: 100,
      score: 1193,
    },
    {
      user_id: 1559298,
      username: 'ochorocho',
      contributor_level: 4,
      opened_merge_requests: 17,
      merged_merge_requests: 8,
      merged_with_issues: 5,
      merged_commits: 3,
      added_notes: 79,
      opened_issues: 13,
      added_labels: 0,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1030,
      plan_points: 149,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1179,
    },
    {
      user_id: 4169165,
      username: 'nagyv',
      contributor_level: 2,
      opened_merge_requests: 13,
      merged_merge_requests: 11,
      merged_with_issues: 0,
      merged_commits: 10,
      added_notes: 2,
      opened_issues: 11,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1120,
      plan_points: 57,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1177,
    },
    {
      user_id: 2002210,
      username: 'schliesser',
      contributor_level: 2,
      opened_merge_requests: 10,
      merged_merge_requests: 8,
      merged_with_issues: 7,
      merged_commits: 9,
      added_notes: 52,
      opened_issues: 8,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1070,
      plan_points: 92,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1162,
    },
    {
      user_id: 19201417,
      username: 'yonghyun.jin13',
      contributor_level: 2,
      opened_merge_requests: 10,
      merged_merge_requests: 8,
      merged_with_issues: 8,
      merged_commits: 8,
      added_notes: 58,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1080,
      plan_points: 63,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1143,
    },
    {
      user_id: 22885337,
      username: 'gnautTheSaturnian',
      contributor_level: 2,
      opened_merge_requests: 17,
      merged_merge_requests: 7,
      merged_with_issues: 6,
      merged_commits: 7,
      added_notes: 43,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1080,
      plan_points: 48,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1128,
    },
    {
      user_id: 30406998,
      username: 'jack1902',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 7,
      merged_with_issues: 6,
      merged_commits: 7,
      added_notes: 171,
      opened_issues: 7,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 920,
      plan_points: 206,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1126,
    },
    {
      user_id: 125864,
      username: 'sue445',
      contributor_level: 2,
      opened_merge_requests: 11,
      merged_merge_requests: 11,
      merged_with_issues: 0,
      merged_commits: 11,
      added_notes: 26,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1100,
      plan_points: 26,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1126,
    },
    {
      user_id: 11715310,
      username: 'Modjo85',
      contributor_level: 3,
      opened_merge_requests: 11,
      merged_merge_requests: 8,
      merged_with_issues: 5,
      merged_commits: 8,
      added_notes: 45,
      opened_issues: 5,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 1010,
      plan_points: 70,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1080,
    },
    {
      user_id: 22397678,
      username: 'SamakshAgarwal1112',
      contributor_level: 2,
      opened_merge_requests: 8,
      merged_merge_requests: 6,
      merged_with_issues: 6,
      merged_commits: 6,
      added_notes: 95,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 7,
      discord_replies: 20,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 820,
      plan_points: 95,
      engage_points: 0,
      discuss_points: 47,
      translate_points: 0,
      bonus_points: 100,
      score: 1062,
    },
    {
      user_id: 28753284,
      username: 'jairosoto05',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 9,
      merged_with_issues: 3,
      merged_commits: 9,
      added_notes: 23,
      opened_issues: 4,
      added_labels: 5,
      closed_issues: 2,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 990,
      plan_points: 58,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1048,
    },
    {
      user_id: 2178476,
      username: 'thomasgl-orange',
      contributor_level: 2,
      opened_merge_requests: 8,
      merged_merge_requests: 6,
      merged_with_issues: 6,
      merged_commits: 6,
      added_notes: 62,
      opened_issues: 11,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 820,
      plan_points: 117,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 100,
      score: 1037,
    },
    {
      user_id: 2410096,
      username: 'JonstonChan',
      contributor_level: 4,
      opened_merge_requests: 9,
      merged_merge_requests: 8,
      merged_with_issues: 5,
      merged_commits: 8,
      added_notes: 25,
      opened_issues: 0,
      added_labels: 30,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 970,
      plan_points: 60,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1030,
    },
    {
      user_id: 26714177,
      username: 'xingli.wu',
      contributor_level: 2,
      opened_merge_requests: 11,
      merged_merge_requests: 7,
      merged_with_issues: 4,
      merged_commits: 5,
      added_notes: 144,
      opened_issues: 4,
      added_labels: 1,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 860,
      plan_points: 165,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1025,
    },
    {
      user_id: 7882302,
      username: 'guillaume.chauvel',
      contributor_level: 3,
      opened_merge_requests: 15,
      merged_merge_requests: 7,
      merged_with_issues: 1,
      merged_commits: 8,
      added_notes: 101,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 910,
      plan_points: 101,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 1011,
    },
    {
      user_id: 20957087,
      username: 'aadarshraghuvanshi5',
      contributor_level: 2,
      opened_merge_requests: 21,
      merged_merge_requests: 5,
      merged_with_issues: 5,
      merged_commits: 5,
      added_notes: 23,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 970,
      plan_points: 23,
      engage_points: 0,
      discuss_points: 1,
      translate_points: 0,
      bonus_points: 0,
      score: 994,
    },
    {
      user_id: 30722311,
      username: 'vijeta004',
      contributor_level: 2,
      opened_merge_requests: 13,
      merged_merge_requests: 6,
      merged_with_issues: 6,
      merged_commits: 6,
      added_notes: 66,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 920,
      plan_points: 66,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 986,
    },
    {
      user_id: 1779412,
      username: 'tonton1728',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 6,
      merged_with_issues: 6,
      merged_commits: 7,
      added_notes: 65,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 4,
      discord_replies: 19,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 860,
      plan_points: 70,
      engage_points: 0,
      discuss_points: 42,
      translate_points: 0,
      bonus_points: 0,
      score: 972,
    },
    {
      user_id: 27146439,
      username: 'Rishcode1',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 7,
      merged_with_issues: 7,
      merged_commits: 7,
      added_notes: 10,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 950,
      plan_points: 15,
      engage_points: 0,
      discuss_points: 1,
      translate_points: 0,
      bonus_points: 0,
      score: 966,
    },
    {
      user_id: 1128501,
      username: 'jlosito',
      contributor_level: 2,
      opened_merge_requests: 14,
      merged_merge_requests: 7,
      merged_with_issues: 1,
      merged_commits: 7,
      added_notes: 81,
      opened_issues: 3,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 870,
      plan_points: 96,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 966,
    },
    {
      user_id: 8558368,
      username: 'dennis.greiner',
      contributor_level: 2,
      opened_merge_requests: 10,
      merged_merge_requests: 8,
      merged_with_issues: 3,
      merged_commits: 8,
      added_notes: 3,
      opened_issues: 2,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 930,
      plan_points: 13,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 943,
    },
    {
      user_id: 19776827,
      username: 'nikitasakau',
      contributor_level: 2,
      opened_merge_requests: 7,
      merged_merge_requests: 7,
      merged_with_issues: 7,
      merged_commits: 7,
      added_notes: 29,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 910,
      plan_points: 29,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 939,
    },
    {
      user_id: 26570790,
      username: 'he-patrick',
      contributor_level: 2,
      opened_merge_requests: 7,
      merged_merge_requests: 5,
      merged_with_issues: 4,
      merged_commits: 6,
      added_notes: 78,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 6,
      discord_replies: 23,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 1,
      code_points: 680,
      plan_points: 78,
      engage_points: 0,
      discuss_points: 52,
      translate_points: 0,
      bonus_points: 100,
      score: 910,
    },
    {
      user_id: 29913074,
      username: 'thenourhan',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 6,
      merged_with_issues: 6,
      merged_commits: 6,
      added_notes: 42,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 2,
      discord_replies: 11,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 840,
      plan_points: 42,
      engage_points: 0,
      discuss_points: 24,
      translate_points: 0,
      bonus_points: 0,
      score: 906,
    },
    {
      user_id: 20121893,
      username: 'refoo0',
      contributor_level: 2,
      opened_merge_requests: 11,
      merged_merge_requests: 8,
      merged_with_issues: 0,
      merged_commits: 10,
      added_notes: 0,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 900,
      plan_points: 0,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 900,
    },
    {
      user_id: 30727778,
      username: 'mohkarem7',
      contributor_level: 2,
      opened_merge_requests: 11,
      merged_merge_requests: 6,
      merged_with_issues: 6,
      merged_commits: 6,
      added_notes: 17,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 880,
      plan_points: 17,
      engage_points: 0,
      discuss_points: 1,
      translate_points: 0,
      bonus_points: 0,
      score: 898,
    },
    {
      user_id: 27021878,
      username: 'aryandutt',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 5,
      merged_with_issues: 5,
      merged_commits: 5,
      added_notes: 117,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 6,
      discord_replies: 12,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 730,
      plan_points: 117,
      engage_points: 0,
      discuss_points: 30,
      translate_points: 0,
      bonus_points: 0,
      score: 877,
    },
    {
      user_id: 13867035,
      username: 'adirn26',
      contributor_level: 2,
      opened_merge_requests: 8,
      merged_merge_requests: 6,
      merged_with_issues: 6,
      merged_commits: 6,
      added_notes: 38,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 820,
      plan_points: 38,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 858,
    },
    {
      user_id: 20624156,
      username: 'niclasheinz',
      contributor_level: 2,
      opened_merge_requests: 8,
      merged_merge_requests: 8,
      merged_with_issues: 0,
      merged_commits: 8,
      added_notes: 1,
      opened_issues: 4,
      added_labels: 1,
      closed_issues: 7,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 1,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 800,
      plan_points: 57,
      engage_points: 0,
      discuss_points: 1,
      translate_points: 0,
      bonus_points: 0,
      score: 858,
    },
    {
      user_id: 22746422,
      username: 'clotman',
      contributor_level: 2,
      opened_merge_requests: 11,
      merged_merge_requests: 5,
      merged_with_issues: 0,
      merged_commits: 5,
      added_notes: 191,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 620,
      plan_points: 196,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 816,
    },
    {
      user_id: 229633,
      username: 'Normo',
      contributor_level: 2,
      opened_merge_requests: 8,
      merged_merge_requests: 6,
      merged_with_issues: 5,
      merged_commits: 6,
      added_notes: 16,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 790,
      plan_points: 16,
      engage_points: 0,
      discuss_points: 1,
      translate_points: 0,
      bonus_points: 0,
      score: 807,
    },
    {
      user_id: 2477108,
      username: 'nomad_blaze',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 6,
      merged_with_issues: 6,
      merged_commits: 6,
      added_notes: 20,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 780,
      plan_points: 25,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 805,
    },
    {
      user_id: 23072133,
      username: 'christian.ceelen',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 6,
      merged_with_issues: 0,
      merged_commits: 7,
      added_notes: 59,
      opened_issues: 10,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 680,
      plan_points: 109,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 789,
    },
    {
      user_id: 11361065,
      username: 'Vulwsztyn',
      contributor_level: 2,
      opened_merge_requests: 8,
      merged_merge_requests: 5,
      merged_with_issues: 3,
      merged_commits: 6,
      added_notes: 76,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 670,
      plan_points: 81,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 751,
    },
    {
      user_id: 10528250,
      username: 'pytgaen',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 6,
      merged_with_issues: 0,
      merged_commits: 7,
      added_notes: 63,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 680,
      plan_points: 68,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 748,
    },
    {
      user_id: 17749792,
      username: 'ivane_gkomarteli',
      contributor_level: 2,
      opened_merge_requests: 7,
      merged_merge_requests: 5,
      merged_with_issues: 5,
      merged_commits: 5,
      added_notes: 29,
      opened_issues: 4,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 690,
      plan_points: 49,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 739,
    },
    {
      user_id: 10465958,
      username: 'tsveti22',
      contributor_level: 2,
      opened_merge_requests: 7,
      merged_merge_requests: 5,
      merged_with_issues: 5,
      merged_commits: 5,
      added_notes: 25,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 3,
      discord_replies: 6,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 690,
      plan_points: 25,
      engage_points: 0,
      discuss_points: 15,
      translate_points: 0,
      bonus_points: 0,
      score: 730,
    },
    {
      user_id: 12085902,
      username: 'mruchann',
      contributor_level: 2,
      opened_merge_requests: 7,
      merged_merge_requests: 5,
      merged_with_issues: 5,
      merged_commits: 5,
      added_notes: 33,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 2,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 690,
      plan_points: 33,
      engage_points: 0,
      discuss_points: 2,
      translate_points: 0,
      bonus_points: 0,
      score: 725,
    },
    {
      user_id: 10449020,
      username: 'tianlu1677',
      contributor_level: 2,
      opened_merge_requests: 9,
      merged_merge_requests: 6,
      merged_with_issues: 0,
      merged_commits: 6,
      added_notes: 43,
      opened_issues: 4,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 660,
      plan_points: 63,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 723,
    },
    {
      user_id: 24876009,
      username: 'peterhdangg',
      contributor_level: 2,
      opened_merge_requests: 3,
      merged_merge_requests: 5,
      merged_with_issues: 5,
      merged_commits: 5,
      added_notes: 20,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 10,
      discord_replies: 39,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 610,
      plan_points: 20,
      engage_points: 0,
      discuss_points: 88,
      translate_points: 0,
      bonus_points: 0,
      score: 718,
    },
    {
      user_id: 750714,
      username: 'tuliren',
      contributor_level: 2,
      opened_merge_requests: 7,
      merged_merge_requests: 7,
      merged_with_issues: 0,
      merged_commits: 7,
      added_notes: 9,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 700,
      plan_points: 9,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 709,
    },
    {
      user_id: 27563100,
      username: 'TimRyanUBS',
      contributor_level: 2,
      opened_merge_requests: 10,
      merged_merge_requests: 6,
      merged_with_issues: 3,
      merged_commits: 1,
      added_notes: 27,
      opened_issues: 2,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 670,
      plan_points: 37,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 707,
    },
    {
      user_id: 25238487,
      username: 'SharkyBytes',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 4,
      merged_commits: 5,
      added_notes: 32,
      opened_issues: 1,
      added_labels: 1,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 3,
      discord_replies: 10,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 640,
      plan_points: 38,
      engage_points: 0,
      discuss_points: 23,
      translate_points: 0,
      bonus_points: 0,
      score: 701,
    },
    {
      user_id: 8687321,
      username: 'samuel_noah1',
      contributor_level: 0,
      opened_merge_requests: 7,
      merged_merge_requests: 7,
      merged_with_issues: 0,
      merged_commits: 7,
      added_notes: 0,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 700,
      plan_points: 0,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 700,
    },
    {
      user_id: 331122,
      username: 'BageDevimo',
      contributor_level: 2,
      opened_merge_requests: 5,
      merged_merge_requests: 5,
      merged_with_issues: 4,
      merged_commits: 5,
      added_notes: 48,
      opened_issues: 3,
      added_labels: 0,
      closed_issues: 1,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 620,
      plan_points: 68,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 688,
    },
    {
      user_id: 7371210,
      username: 'betty-godier',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 4,
      merged_commits: 5,
      added_notes: 10,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 4,
      discord_replies: 2,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 640,
      plan_points: 10,
      engage_points: 0,
      discuss_points: 8,
      translate_points: 0,
      bonus_points: 0,
      score: 658,
    },
    {
      user_id: 12245858,
      username: 'Ruislip',
      contributor_level: 2,
      opened_merge_requests: 7,
      merged_merge_requests: 6,
      merged_with_issues: 0,
      merged_commits: 7,
      added_notes: 14,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 640,
      plan_points: 14,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 654,
    },
    {
      user_id: 866625,
      username: 'zavoloklom',
      contributor_level: 2,
      opened_merge_requests: 13,
      merged_merge_requests: 5,
      merged_with_issues: 0,
      merged_commits: 4,
      added_notes: 0,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 640,
      plan_points: 5,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 645,
    },
    {
      user_id: 2376752,
      username: 'ipsavitsky234',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 3,
      merged_commits: 5,
      added_notes: 19,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 610,
      plan_points: 24,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 634,
    },
    {
      user_id: 564782,
      username: 'beber80',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 0,
      merged_commits: 6,
      added_notes: 41,
      opened_issues: 10,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 540,
      plan_points: 91,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 631,
    },
    {
      user_id: 18525836,
      username: '30Piraten',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 3,
      merged_commits: 2,
      added_notes: 77,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 550,
      plan_points: 77,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 627,
    },
    {
      user_id: 3399361,
      username: 'adirelle',
      contributor_level: 2,
      opened_merge_requests: 10,
      merged_merge_requests: 5,
      merged_with_issues: 0,
      merged_commits: 5,
      added_notes: 1,
      opened_issues: 4,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 600,
      plan_points: 21,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 621,
    },
    {
      user_id: 10058918,
      username: 'blackstream-x',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 6,
      merged_with_issues: 0,
      merged_commits: 6,
      added_notes: 0,
      opened_issues: 2,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 600,
      plan_points: 10,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 610,
    },
    {
      user_id: 1965376,
      username: 'duncanmmacleod',
      contributor_level: 3,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 1,
      merged_commits: 5,
      added_notes: 23,
      opened_issues: 5,
      added_labels: 1,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 550,
      plan_points: 49,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 599,
    },
    {
      user_id: 617802,
      username: 'jtymes',
      contributor_level: 2,
      opened_merge_requests: 5,
      merged_merge_requests: 5,
      merged_with_issues: 2,
      merged_commits: 5,
      added_notes: 25,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 1,
      discord_replies: 2,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 560,
      plan_points: 25,
      engage_points: 0,
      discuss_points: 5,
      translate_points: 0,
      bonus_points: 0,
      score: 590,
    },
    {
      user_id: 25927363,
      username: 'kdreyer',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 1,
      merged_commits: 5,
      added_notes: 19,
      opened_issues: 3,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 550,
      plan_points: 34,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 584,
    },
    {
      user_id: 26970108,
      username: 'MaciejVindsburg',
      contributor_level: 2,
      opened_merge_requests: 7,
      merged_merge_requests: 7,
      merged_with_issues: 0,
      merged_commits: 1,
      added_notes: 0,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 580,
      plan_points: 0,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 580,
    },
    {
      user_id: 6361776,
      username: 'AaronDewes',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 1,
      merged_commits: 5,
      added_notes: 24,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 550,
      plan_points: 29,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 579,
    },
    {
      user_id: 25783786,
      username: 'brayden-lm',
      contributor_level: 2,
      opened_merge_requests: 5,
      merged_merge_requests: 5,
      merged_with_issues: 0,
      merged_commits: 6,
      added_notes: 40,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 520,
      plan_points: 40,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 560,
    },
    {
      user_id: 363512,
      username: 'zadkiel',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 0,
      merged_commits: 5,
      added_notes: 11,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 520,
      plan_points: 11,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 531,
    },
    {
      user_id: 19423278,
      username: 'marc.b.orange',
      contributor_level: 2,
      opened_merge_requests: 5,
      merged_merge_requests: 5,
      merged_with_issues: 0,
      merged_commits: 5,
      added_notes: 18,
      opened_issues: 1,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 500,
      plan_points: 23,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 523,
    },
    {
      user_id: 10025395,
      username: 'ZachThill',
      contributor_level: 2,
      opened_merge_requests: 6,
      merged_merge_requests: 5,
      merged_with_issues: 0,
      merged_commits: 5,
      added_notes: 0,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 520,
      plan_points: 0,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 520,
    },
    {
      user_id: 750459,
      username: 'jsonc',
      contributor_level: 0,
      opened_merge_requests: 5,
      merged_merge_requests: 5,
      merged_with_issues: 0,
      merged_commits: 5,
      added_notes: 0,
      opened_issues: 0,
      added_labels: 0,
      closed_issues: 0,
      added_events: 0,
      added_contents: 0,
      discord_messages: 0,
      discord_replies: 0,
      forum_posts: 0,
      forum_replies: 0,
      translated_strings: 0,
      ai_contributions: 0,
      bonuses: 0,
      code_points: 500,
      plan_points: 0,
      engage_points: 0,
      discuss_points: 0,
      translate_points: 0,
      bonus_points: 0,
      score: 500,
    },
  ],
};
